/* QBX Produktkacheln (Entwurf Claude, 24.09.2026): Beliebtheit + Mengenrabatt für alle .qbx-card auf der Seite.
   Konfiguration je Raster über data-Attribute am Container [data-qbx-grid]:
     data-pop-url = qbx-popularity.json (Liste „popular“ = Handles über der Schwelle; Schwelle nur im Cron-Job).
   Rabattstaffel je Kachel aus data-tiers="2:10|3:15" (Snippet qbx-card rechnet sie aus dem Metafeld custom.volume_pricing,
   das die Digistore-App pflegt) – keine Handpflege im Theme.
   Beliebtheit: aus echten Käufen der letzten 7 Tage (projects/shop_theme/src/popularity.py, täglich per Cron); die Zahl
   selbst wird NICHT veröffentlicht (Vorgabe Inhaber 25.09.2026). „popular“ = {handle: Stufe}: 1 „Viele Käufe, rechtzeitig
   bestellen“, 2 „Sehr viele Käufe, beeile dich“ (Stufen nur im Cron-Job).
   Mengenrabatt: folgt dem Digistore-Warenkorb (window.onDigistoreCartChange, gross_amount = rabattierter Stückpreis). */
(function () {
  var ICON = '<svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 4-6 8-6s8 2 8 6"/></svg>';
  var CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 12 5 5 9-10"/></svg>';
  var PLUS = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
  var popData = null, popLoading = null;
  var POP_TEXT = { 1: ['Viele Käufe, rechtzeitig bestellen', 'Viele Käufe'], 2: ['Sehr viele Käufe, beeile dich', 'Sehr viele Käufe'] };
  window.qbxPopText = function (level) { var t = POP_TEXT[level] || POP_TEXT[1]; return window.innerWidth < 990 ? t[1] : t[0]; };
  window.qbxPopLevel = function (d, handle) { if (!d || !d.popular) return 0; var v = d.popular[handle]; if (v === undefined && Array.isArray(d.popular)) v = d.popular.indexOf(handle) >= 0 ? 1 : 0; return Number(v) || 0; };
  function eur(v) { return v.toFixed(2).replace('.', ',') + ' €'; }
  function grids() { return Array.prototype.slice.call(document.querySelectorAll('[data-qbx-grid]')); }
  function parseTiers(str) {
    return (str || '').split('|').map(function (t) { var p = t.split(':'); return { qty: Number(p[0]), pct: Number(p[1]) }; })
      .filter(function (t) { return t.qty > 0 && t.pct > 0; }).sort(function (a, b) { return a.qty - b.qty; });
  }
  function loadPop(url) {
    if (popData) return Promise.resolve(popData);
    if (!popLoading) popLoading = fetch(url, { cache: 'no-store' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) { popData = d; return d; }).catch(function () { return null; });
    return popLoading;
  }
  function applyPop() {
    grids().forEach(function (g) {
      var url = g.dataset.popUrl; if (!url) return;
      loadPop(url).then(function (d) {
        if (!d || !d.popular) return;
        g.querySelectorAll('.qbx-card[data-handle]').forEach(function (card) {
          if (card.dataset.popDone) return;
          var level = window.qbxPopLevel(d, card.dataset.handle); if (!level) return;
          card.dataset.popDone = '1';
          var badge = card.querySelector('[data-pop-badge]'), pop = card.querySelector('[data-pop]');
          if (badge) { badge.hidden = false; if (level >= 2) badge.textContent = 'Sehr beliebt'; }
          if (pop) { pop.querySelector('.qbx-card__pop-icons').innerHTML = ICON + ICON + ICON; pop.querySelector('[data-pop-text]').textContent = window.qbxPopText(level); pop.hidden = false; }
        });
      });
    });
  }
  function renderTiers(cart) {
    var byId = {}; ((cart && cart.items) || []).forEach(function (i) { byId[String(i.product_id)] = i; });
    grids().forEach(function (g) {
      g.querySelectorAll('.qbx-card[data-ds-id]').forEach(function (card) {
        var TIERS = parseTiers(card.dataset.tiers || g.dataset.tiers); if (!TIERS.length) return;
        var tier = card.querySelector('[data-tier]'), price = card.querySelector('.qbx-card__price'); if (!tier || !price) return;
        var base = Number(card.dataset.price || 0), item = byId[card.dataset.dsId], qty = item ? Number(item.quantity || 0) : 0;
        var unit = item && Number(item.gross_amount) > 0 ? Number(item.gross_amount) : base;
        var active = null, next = null;
        TIERS.forEach(function (t) { if (qty >= t.qty) active = t; else if (!next) next = t; });
        var txt = '';
        if (qty) {
          if (active) txt += '<span class="on">' + CHECK + active.pct + ' %</span>';
          if (next) txt += '<span>' + PLUS + (next.qty - qty) + ' = ' + next.pct + ' %</span>';
        }
        tier.innerHTML = txt;
        price.innerHTML = (unit < base - 0.005 ? '<s>' + eur(base) + '</s>' : '') + eur(unit);
      });
    });
  }
  function hook() {
    var prev = window.onDigistoreCartChange;
    if (!(prev && prev.__qbxTierHooked)) {
      var fn = function (cart) { if (prev) prev(cart); renderTiers(cart); }; fn.__qbxTierHooked = true; window.onDigistoreCartChange = fn;
    }
    renderTiers(window.ds24cart || null);
    applyPop();
  }
  /* Vorbestell-Countdown auf Kacheln (Epoch aus Liquid); Produktseite hat einen eigenen Countdown, daher nur .qbx-card */
  function countdowns() {
    document.querySelectorAll('.qbx-card [data-qbx-countdown]:not([data-cd-on])').forEach(function (el) {
      el.dataset.cdOn = '1'; var end = Number(el.dataset.qbxCountdown) * 1000; if (!end) return;
      function p(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var d = end - Date.now();
        if (d <= 0) { el.textContent = el.dataset.done || 'jetzt'; return; }
        var s = Math.floor(d / 1000), days = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sc = s % 60;
        el.textContent = days ? days + (days === 1 ? ' Tag ' : ' Tage ') + h + ' Std' : h + ' Std ' + p(m) + ' Min ' + p(sc) + ' Sek';
        setTimeout(tick, 1000);
      }
      tick();
    });
  }
  window.qbxCardsRefresh = function () { hook(); countdowns(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', window.qbxCardsRefresh); else window.qbxCardsRefresh();
  window.addEventListener('load', window.qbxCardsRefresh);
})();
